import React, { useState } from 'react'
import { BlockchainIconPath } from 'src/constants/Paths'

function getBlockchainIconURL(blockchain: string, fileType: string = 'svg') {
  return BlockchainIconPath.replace(':blockchain_name', blockchain.replace(" ", "%20")).replace(':file_type', fileType)
}

const blockchainNameMap: {
  [index: string]: string
} = {
  "Native": "Carbon",
  "Terraclassic": "Terra",
  "Eth": "Ethereum",
  "Bsc": "Binance Smart Chain",
  "Tradehub": "TradeHub-filled",
  "Okx": "OKC",
  "Zil": "Zilliqa",
  "Cosmoshub": "Cosmos Hub",
  "Juno": "Juno-filled",
  "Terra2": "Terra",
  "Stafi": "Stafihub",
  "Persistence": "Persistence Core",
  "Omniflix": "Omniflix Hub",
  "Noble": "Noble-filled",
  "Irishub": "Iris Hub",
  "Dydx": "DYDX",
  "Archway": "Archway-filled",
  "Secret": "Secret-Network",
  "Optimism": "Optimism-filled",
  "Avax": "Avalanche-filled",
  "Monad": "Monad-Testnet-filled",
}

export interface BlockchainIconProps {
  blockchain?: string
  className?: string
}


const BlockchainIcon: React.FunctionComponent<BlockchainIconProps> = (
  props: BlockchainIconProps,
) => {
  const { blockchain, className } = props
  const [imageSrcError, setImageSrcError] = useState(false);
  const [imageSrcIndex, setImageSrcIndex] = useState(0);


  let defaultIcon: React.ReactNode = <div className={`blockchain-placeholder ${className}`}>?</div>
  if (!blockchain || blockchain.length === 0) {
    return defaultIcon
  }

  let symbolToFetch = ""
  if (blockchain) {
    const blockchainName = blockchain.charAt(0).toUpperCase() + blockchain.slice(1)
    symbolToFetch = blockchainNameMap[blockchainName] ?? (blockchainName === 'Ibc' ? 'IBC' : blockchainName)
  }

  const imageSrcArray = symbolToFetch
    ? [
      getBlockchainIconURL(symbolToFetch, 'svg'),
      getBlockchainIconURL(symbolToFetch, 'png'),
    ] : []

  const handleImgSrcError = () => {
    if (imageSrcIndex < imageSrcArray.length - 1) {
      setImageSrcIndex(imageSrcIndex + 1);
    } else {
      setImageSrcError(true);
    }
  }

  return !imageSrcError && symbolToFetch ? (
    <img className={className} src={imageSrcArray[imageSrcIndex]} onError={handleImgSrcError} alt={symbolToFetch} title={symbolToFetch} />
  ) : defaultIcon
}

export default BlockchainIcon
